import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ApolloProvider } from "@apollo/client/react";
import { I18nextProvider } from "react-i18next";
import { apolloClient } from "./graphql/client";
import { validateStoredAuth } from "./auth/auth-service";
import { initSentry } from "./lib/sentry";
import { router } from "./routes";
import i18n from "./i18n";
import "@fontsource-variable/space-grotesk";
import "./app.css";

// Initialize Sentry before React renders
initSentry();

// Validate stored auth on startup (clears corrupt localStorage)
validateStoredAuth();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found. Ensure index.html has a <div id='root'></div>.");
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ApolloProvider client={apolloClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </I18nextProvider>
  </StrictMode>,
);
